export default __webpack_public_path__ + "static/media/fastingtimer@2x.3e4259a6.jpg";